import { Component, Input, inject, input } from '@angular/core';
import {ButtonModule} from "primeng/button";
import {DataService} from "../../service/data.service";
import {DialogModule} from "primeng/dialog";
import {BadgeModule} from "primeng/badge";
import {PaginatorModule} from "primeng/paginator";
import {Comment, Reply} from "./RNG_Comments";
import {ToggleSwitchModule} from "primeng/toggleswitch";
import {InputTextModule} from "primeng/inputtext";
import {TextareaModule} from "primeng/textarea";
import {RadioButtonModule} from "primeng/radiobutton";
import {CardModule} from "primeng/card";
import {AccordionModule} from "primeng/accordion";
import {PlatformUser} from "../../api/db/entities/PlatformUser";

@Component({
    selector: 'comment',
    templateUrl: './comment.component.html',
    imports: [
    ButtonModule,
    DialogModule,
    BadgeModule,
    PaginatorModule,
    ToggleSwitchModule,
    InputTextModule,
    TextareaModule,
    RadioButtonModule,
    CardModule,
    AccordionModule
],
    styleUrl: './comment.component.scss'
})
export class CommentComponent {
    private dataService = inject(DataService);


    readonly user = input<PlatformUser>(undefined);

    //Need to know what role I have on this specific project
    // TODO: Skipped for migration because:
    //  Your application code writes to the input. This prevents migration.
    @Input() comment: Comment;
    readonly isNew = input<boolean>(undefined);
    // TODO: Skipped for migration because:
    //  Your application code writes to the input. This prevents migration.
    @Input() baseReply: Reply;

    submitted: boolean =  false;
    protected readonly Reply = Reply;
}
